import "./App.css";
// import { createBrowserRouter, RouterProvider,BrowserRouter, Routes, Route } from "react-router-dom";
import routes from "./utlis/routes";
import Layout from "./layout/index";

import Home from './pages/home_screen/index';
import see_all from './pages/see_all';
import Detail from './pages/detail/Detail(not_use_right_now)';

import { MusicProvider } from "./context/MusicContext";
import { AudioProvider } from "./context/AudioContext";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { SliderProvider } from "./context/SliderContext";
import { AudioPlayerProvider } from "./context/AudioPlayerContext";
import ScrollToTop from "./components/ScrollToTop";

function App() {

  const router = createHashRouter([
    {
      // parent route component
      Component: Layout,
      // child route components
      children: routes.map((route) => {
            return {
              path: route.path,
              // element: <route.component />,
              element: route.element || <route.component />

            };
          })
    },
  ]);

  return (
    <MusicProvider>
      <AudioProvider>
      {/* <RouterProvider router={router} /> */}
        <SliderProvider>
          <RouterProvider router={router} />
        </SliderProvider>
      </AudioProvider>
    </MusicProvider>
  );

  // return (
  //   <Layout>
  //     <RouterProvider router={router} />
  //   </Layout>

    // <RouterProvider router={router} />
    // <BrowserRouter basename="/">
    //   <Routes>
    //     <Route path="" element={<HomeScreen />} />
    //   </Routes>
    // </BrowserRouter>
    // <BrowserRouter basename="/app">
    //   <Routes>
    //     <Route path="/" Component={HomeScreen} />
    //   </Routes>
    // </BrowserRouter>
    // <Layout>
    //   <RouterProvider
    //     router={router}
    //     fallbackElement={<p>Initial Load...</p>}
    //   />
    // </Layout>
    // <Layout>
    //   <HomeScreen />
    // </Layout>
  // );
}

export default App;
